var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_3d",
    transform: "translate(-983 -519)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 400,
    height: 400,
    transform: "translate(983 519)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon:_3D",
    "data-name": "Icon: 3D",
    transform: "translate(1149.5 688.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M7,187a7,7,0,0,1-7-7V131a7,7,0,0,1,7-7H63a7,7,0,0,1,7,7v49a7,7,0,0,1-7,7Z",
    transform: "translate(-1.5 -125.535)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M32.5,24.778V12.333a3.111,3.111,0,0,0-1.556-2.691L20.056,3.42a3.111,3.111,0,0,0-3.111,0L6.056,9.642A3.111,3.111,0,0,0,4.5,12.333V24.778a3.111,3.111,0,0,0,1.556,2.691l10.889,6.222a3.111,3.111,0,0,0,3.111,0l10.889-6.222A3.111,3.111,0,0,0,32.5,24.778Z",
    transform: "translate(15 11.346)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M4.905,10.44,18.485,18.3l13.58-7.856",
    transform: "translate(15.015 11.621)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M18,33.68V18",
    transform: "translate(15.5 11.901)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder3D);
export default __webpack_public_path__ + "static/media/placeholder_3d.26beb485e2eef0e843e303286082f77b.svg";
export { ForwardRef as ReactComponent };